import React from 'react';
import { FDStack } from '@facet-wealth/design';
import { ActivityRow } from 'Views/Page/Content/Templates/MemberDashboard/content/ActivityTabs/content/ActivityRow';
import fr from 'facet-rest';

const ActivityItems = ({ collection }) => {
  const memberActivitySummaryResources = collection.resources().list();

  return (
    <FDStack>
      {memberActivitySummaryResources.map(
        memberActivitySummaryResource => (
          <ActivityRow memberActivitySummaryResource={memberActivitySummaryResource} />
        ),
      )}
    </FDStack>
  );
};

ActivityItems.defaultProps = {};

ActivityItems.propTypes = {
  collection: fr.Collection.isRequired,
};

export { ActivityItems };
